import { useTypedQuery } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

export const useCancellationReasonsQuery = () =>
  useTypedQuery({
    queryKey: AppointmentDetailsKeys.cancellationReasons,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.get(endpoint, baseUrl)).data.reasons
  });
